import { svgs } from "../assets/svgs"
import { tracking } from "../utils/tracking"


const cards = [
   {
      svg: svgs.agtech,
      name: 'Agtech',
   },
   {
      svg: svgs.AI,
      name: 'AI',
   },
   {
      svg: svgs.biotech,
      name: 'Biotech',
   },
   {
      svg: svgs.blockchain,
      name: 'Blockchain / Web3',
   },
   {
      svg: svgs.cleantech,
      name: 'Climate Tech',
   },
   {
      svg: svgs.consumer,
      name: 'Consumer Tech',
   },
   {
      svg: svgs.CPG,
      name: 'CPG',
   },
   {
      svg: svgs.cyber,
      name: 'Cyber',
   },
   {
      svg: svgs.ecommerce,
      name: 'eCommerce',
   },
   {
      svg: svgs.edtech,
      name: 'EdTech',
   },
   {
      svg: svgs.enterprise,
      name: 'Enterprise Tech',
   },
   {
      svg: svgs.fintech,
      name: 'Fintech',
   },
   {
      svg: svgs.foodtech,
      name: 'Foodtech',
   },
   {
      svg: svgs.gaming,
      name: 'Gaming',
   },
   {
      svg: svgs.health,
      name: 'Health Tech',
   },
   {
      svg: svgs.iot,
      name: 'IoT',
   },
   {
      svg: svgs.lifeSciences,
      name: 'Life Sciences',
   },
   {
      svg: svgs.marketing,
      name: 'Marketing Tech',
   },
   {
      svg: svgs.medtech,
      name: 'Medtech',
   },
   {
      svg: svgs.proptech,
      name: 'Proptech',
   },
   {
      svg: svgs.robotics,
      name: 'Robotics',
   },
   {
      svg: svgs.saas,
      name: 'Saas',
   },
   {
      svg: svgs.transportation,
      name: 'Transportation',
   },
   {
      svg: svgs.VR,
      name: 'VR/ Metaverse',
   },
]

export const FeaturedSectors = () => {
   return (
      <div className='featured-sectors-container'>
         {svgs.backgroundLogo}
         <div className='featured-sectors'>
            <h1>Call for Top Innovators</h1>
            <p>
               A select group of more than <span>100 Top Innovators</span> from the following sectors will be chosen to showcase their breakthrough investment opportunities to an exclusive audience of Venture Capitalists, Corporate Investors, Private Investors, Investment Bankers, and Strategic Partners.
            </p>
            <h2>Featured Sectors</h2>
            <section className="cards-container">
               {
                  cards.map((card, cardIdx) =>
                     <div key={cardIdx} className='card'>
                        {card.svg}
                        <h3>{card.name}</h3>
                     </div>
                  )
               }
            </section>
            <div className='motto'>
               <h3>Get Noticed</h3>
               {svgs.chevronRight}
               <h3> Get Funded</h3>
               {svgs.chevronRight}
               <h3>Grow Faster</h3>
            </div>
            {/* <a className='btn' href='https://account.youngstartup.com/' onClick={() => tracking(284)}>
               Apply To Present
            </a > */}
         </div>
      </div>
   )
}
